import React from 'react'
import Page6 from '../components/Page6'
import Header from '../components/Header'
import { Helmet } from "react-helmet";

export default function ContactUs() {
  return (
    
    <div>
      <Helmet>
        <title>Contact Us | Andromeda</title>
        <meta name="description" content="Get in touch with us through our contact page." />
        <meta name="keywords" content="contact, support, help, andromeda sim" />
      </Helmet>
     <div className=''><Header/></div>
        <Page6/>
    </div>
  )
}
